export default "Diagnostic CEE Professionnel — Estimez vos primes | Solution Éco France";

